export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "talk-JitsiStreamBackgroundEffect.worker.worker.js?v=2152220e2d9b93980901");
}
